<div class="main">
  <mat-dialog-content>
    <p><strong>{{text}}</strong></p>
  </mat-dialog-content>
</div>
